/**
 * gist-a11y.js — reading & display preferences.
 *
 * The boot snippet in <head> has already applied any saved preferences before
 * first paint; this file only wires the panel. It therefore reads the current
 * state off <html> rather than off storage, so the radios can never disagree
 * with what the page is actually showing (they would if storage were written
 * by one tab while another had the panel open).
 *
 * Progressive enhancement: with JS off the button and dialog simply never
 * activate, and the page renders exactly as it does today.
 */
(function () {
  'use strict';

  var KEY = 'gx-a11y';
  var root = document.documentElement;
  var openBtn = document.getElementById('gxa11y-open');
  var dialog = document.getElementById('gxa11y-dialog');
  if (!openBtn || !dialog || typeof dialog.showModal !== 'function') {
    // No <dialog> support: hide the trigger rather than leave a dead control.
    if (openBtn) openBtn.hidden = true;
    return;
  }

  /* Each control: the attribute it drives and its non-default value. Keeping
     the default out of the DOM means "standard" leaves no attribute behind and
     the CSS below has nothing to match — the site stays byte-identical for
     anyone who never changes a setting. */
  var CONTROLS = [
    { name: 'gxa11y-contrast', attr: 'data-a11y-contrast', key: 'contrast', on: 'high' },
    { name: 'gxa11y-font',     attr: 'data-a11y-font',     key: 'font',     on: 'readable' },
    { name: 'gxa11y-density',  attr: 'data-a11y-density',  key: 'density',  on: 'compact' }
  ];

  function save() {
    var prefs = {};
    CONTROLS.forEach(function (c) {
      var v = root.getAttribute(c.attr);
      if (v) prefs[c.key] = v;
    });
    try {
      if (Object.keys(prefs).length) localStorage.setItem(KEY, JSON.stringify(prefs));
      else localStorage.removeItem(KEY);
    } catch (e) {
      /* Storage unavailable (private mode, blocked cookies). The preference
         still applies for this page view; it just will not persist. Failing
         silently is right here — surfacing a storage error would be noise. */
    }
  }

  function syncRadios() {
    CONTROLS.forEach(function (c) {
      var current = root.getAttribute(c.attr);
      var inputs = dialog.querySelectorAll('input[name="' + c.name + '"]');
      Array.prototype.forEach.call(inputs, function (input) {
        input.checked = current ? input.value === current : input.value !== c.on;
      });
    });
  }

  function apply(control, value) {
    if (value === control.on) root.setAttribute(control.attr, value);
    else root.removeAttribute(control.attr);
    save();
  }

  dialog.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.type !== 'radio') return;
    var control = CONTROLS.filter(function (c) { return c.name === input.name; })[0];
    if (control) apply(control, input.value);
  });

  document.getElementById('gxa11y-reset').addEventListener('click', function () {
    CONTROLS.forEach(function (c) { root.removeAttribute(c.attr); });
    save();
    syncRadios();
  });

  document.getElementById('gxa11y-close').addEventListener('click', function () { dialog.close(); });

  openBtn.addEventListener('click', function () {
    syncRadios();
    dialog.showModal();
    /* Mark the control as discovered so it can shrink to an icon from now on.
       Stored separately from the preferences themselves: someone can explicitly
       choose all-defaults, which clears gx-a11y, and they should still keep the
       compact trigger rather than have the full label reappear. */
    if (!root.hasAttribute('data-a11y-seen')) {
      root.setAttribute('data-a11y-seen', '1');
      try { localStorage.setItem('gx-a11y-seen', '1'); } catch (e) {}
    }
  });

  /* Native <dialog> already restores focus to the trigger on close and traps
     focus while open, so there is no focus management to write here. It also
     handles Escape. Clicking the backdrop does not close by default, so add
     that: the click lands on the dialog element itself only when it is outside
     the inner panel. */
  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) dialog.close();
  });
})();
